import { Directive, input } from '@angular/core';
import type { FieldTree } from '@angular/forms/signals';

@Directive({
  standalone: true,
  selector: '[formFieldControl]',
  host: {
    'class': 'form-field',
    '[class.invalid]': 'this.formFieldControl()().invalid()',
    '[class.dirty]': 'this.formFieldControl()().dirty()',
    '[class.disabled]': 'this.formFieldControl()().disabled()',
    '[class.touched]': 'this.formFieldControl()().touched()',
  }
})
export class FormFieldDirective<T> {
  public readonly formFieldControl = input.required<FieldTree<T>>();
}
